import { ApiError, apiInstance, apiResponse, getLoadingState } from '../../Api';
import { AlunoModel } from './Model';

export const fetchTodosAlunos = async (
    page: number,
    pageSize: number,
    search: string
): Promise<apiResponse<AlunoModel[]>> => {
    try {
        const fetchResponce = await apiInstance.get<AlunoModel[]>(
            '/funcionario/alunos',
            { params: { page, pageSize, search } }
        );
        return {
            data: fetchResponce.data,
            status: getLoadingState(fetchResponce.status)
        } as apiResponse<AlunoModel[]>;
    } catch (e) {
        const status = e.response ? e.response.status : 500;
        return {
            data: [],
            status: getLoadingState(status)
        } as apiResponse<AlunoModel[]>;
    }
};

export const fecthAluno = async (
    alunoId: number
): Promise<apiResponse<AlunoModel | undefined>> => {
    try {
        const fetchResponce = await apiInstance.get<AlunoModel>(
            `/funcionario/alunos/${alunoId}`
        );

        return {
            data: fetchResponce.data,
            status: getLoadingState(fetchResponce.status)
        } as apiResponse<AlunoModel>;
    } catch (e) {
        const status = e.response ? e.response.status : 500;
        return {
            data: undefined,
            status: getLoadingState(status)
        } as apiResponse<undefined>
    }
};

export const fecthAlunoParaAutenticacaoPreProjeto = async ():
    Promise<apiResponse<AlunoModel | undefined>> => {
    try {
        const fetchResponce = await apiInstance.get<AlunoModel>(
            `aluno/autenticacao` 
        );

        return {
            data: fetchResponce.data,
            status: getLoadingState(fetchResponce.status)
        } as apiResponse<AlunoModel>;
    } catch (e) {
        const status = e.response ? e.response.status : 500;
        
        return {
            data: undefined,
            status: getLoadingState(status)
        } as apiResponse<undefined>
    }
};

export const ativarDesativarUmAluno = async (
    alunoId: number,
    alunoAtivo: boolean
): Promise<apiResponse<ApiError[]>> => {
    try {
        const fetchResponce = await apiInstance.post(
            'funcionario/alunos/ativar',
            { alunoId, alunoAtivo }
        );
        return {
            data: [],
            status: getLoadingState(fetchResponce.status)
        };
    } catch (e) {
        const status = e.response ? e.response.status : 500;

        return {
            data: e.response ? e.response.data : [],
            status: getLoadingState(status)
        };
    }
};